import type { BenefitProperty } from "@circle-react/types/PaywallCustomization";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { Icon } from "./Icon";

export const Benefit = ({ title, description, icon }: BenefitProperty) => (
  <div
    className="grid grid-cols-8 gap-x-3 md:grid-cols-12"
    data-testid="benefit-item"
  >
    <div className="col-span-1 max-h-[1.875rem] md:col-span-1">
      <Icon icon={icon} />
    </div>
    <div className="col-span-7 flex items-center md:col-span-11">
      <Typography.LabelSm weight="semibold" data-testid="benefit-title-item">
        {title}
      </Typography.LabelSm>
    </div>
    <div className="col-span-1" />
    <div
      className="col-span-7 flex items-center md:col-span-11"
      data-testid="benefit-description-item"
    >
      <Typography.BodySm>{description}</Typography.BodySm>
    </div>
  </div>
);
